import Backend from "../../../Backend";

export const getBundles = () =>
  Backend.post("api/bundles/list");

export const getActiveBundles = () =>
  Backend.post("api/bundles/active");

export const getBundle = (id) =>
  Backend.get(`api/bundles/${id}`);

export const createBundle = (bundleData) =>
  Backend.post("api/bundles", bundleData);

export const updateBundle = (id, bundleData) =>
  Backend.put(`api/bundles/${id}`, bundleData);

export const deleteBundle = (id) =>
  Backend.delete(`api/bundles/${id}`);

export const addItemToBundle = (bundleId, productId, quantity) =>
  Backend.post(`api/bundles/${bundleId}/items`, { productId, quantity });

export const removeItemFromBundle = (bundleId, itemId) =>
  Backend.delete(`api/bundles/${bundleId}/items/${itemId}`);
